
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","fill-rule":"evenodd","d":"M27.45 6.625a3.43 3.43 0 0 0-3.433 0l-6.461 3.734a3.44 3.44 0 0 0-1.717 2.977v7.47c0 1.228.654 2.363 1.717 2.976l5.714 3.303v15.258c0 1.406 1.594 2.217 2.728 1.389l1.514-1.105a1.72 1.72 0 0 0 .705-1.389v-1.73c.996-.306 2.114-.644 2.114-1.92v-2.943c0-1.257-1.102-1.606-2.078-1.943l-.036-.011v-5.617l5.695-3.292a3.44 3.44 0 0 0 1.717-2.976v-7.47a3.44 3.44 0 0 0-1.717-2.977zM25.735 17.07a2.286 2.286 0 0 0 2.285-2.288 2.286 2.286 0 1 0-4.57 0 2.286 2.286 0 0 0 2.285 2.288","clip-rule":"evenodd"}}),_c('path',{attrs:{"stroke":"#234652","d":"M25.53 5.56a3.43 3.43 0 0 0-3.433 0l-6.461 3.734a3.44 3.44 0 0 0-1.717 2.977v7.47c0 1.227.654 2.362 1.717 2.976l5.714 3.303v15.258c0 1.405 1.594 2.217 2.728 1.389l1.514-1.105a1.72 1.72 0 0 0 .706-1.39v-1.73c.996-.306 2.113-.644 2.113-1.92V33.58c0-1.257-1.102-1.606-2.078-1.942l-.035-.012V26.01l5.694-3.292a3.44 3.44 0 0 0 1.717-2.977v-7.47a3.44 3.44 0 0 0-1.717-2.976zm-1.716 10.446a2.286 2.286 0 0 0 2.285-2.288 2.286 2.286 0 0 0-2.285-2.288 2.286 2.286 0 0 0-2.285 2.288 2.286 2.286 0 0 0 2.285 2.288Z","clip-rule":"evenodd"}})])
          )
        }
      }
    